module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/eye.svg?2e7692e0376ff2b1f2e67d9416d84067";